import React from 'react';

interface Props {
  size?: number;
  className?: string;
  alt?: string;
}

/**
 * V4.9.2+ — Renders the Ticket Management circular brand mark. Source SVG
 * lives in /public/bs-logo.svg (kept as the filename for the existing
 * favicon binding). To swap in a custom PNG / SVG provided by ops:
 *   1. Drop the new file at /public/bs-logo.svg (square 200x200 SVG)
 *      OR /public/bs-logo.png (square PNG, 256+ px)
 *   2. If using PNG, change the `src` below to "/bs-logo.png".
 */
export function BrandMark({ size = 32, className, alt = 'Ticket Management' }: Props) {
  return (
    <img
      src="/bs-logo.svg"
      alt={alt}
      width={size}
      height={size}
      className={className}
      style={{ display: 'block', borderRadius: '50%' }}
    />
  );
}
